import { EInvoiceAddressSchemeType, isValidEInvoiceAddressFormat } from '@components'

import { TFunction } from 'i18next'
import isEmpty from 'lodash/isEmpty'
import { z } from 'zod'

import { XRechnungEInvoicingAddressFormSchema } from '../types/xRechnungEInvoicingAddressFormSchema'

export const getXRechnungEInvoicingAddressFormSchema = (
  t: TFunction,
  countryId?: string,
): XRechnungEInvoicingAddressFormSchema => {
  return z
    .object({
      ean: z
        .string()
        .trim()
        .transform((address) => address.replace(/\s/g, '')),
      eInvoiceScheme: z.nativeEnum(EInvoiceAddressSchemeType).or(z.literal('')),
      publicEntityRoutingEnabled: z.boolean().optional(),
    })
    .superRefine((data, ctx) => {
      const address = data.ean
      const scheme = data.eInvoiceScheme
      const isPublicEntity = data.publicEntityRoutingEnabled
      const isEInvoiceAddressFormatInvalid =
        scheme && address && !isValidEInvoiceAddressFormat(address, scheme, countryId)
      const isEInvoiceAddressRequired = scheme === EInvoiceAddressSchemeType.LWID && isPublicEntity && isEmpty(address)

      if (isEInvoiceAddressFormatInvalid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['ean'],
          message: t('external_invoices.download_as_xrechnung.modal.form.field.e_invoice_address.error.invalid_format'),
        })
      }

      if (isEInvoiceAddressRequired) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['ean'],
          message: t(
            'external_invoices.download_as_xrechnung.modal.form.field.e_invoice_address.error.e_invoice_address_required_for_LWID',
          ),
        })
      }
    })
}
